import React from 'react';
import { motion } from 'framer-motion';
import ScrollReveal from './ScrollReveal';
import './ContactBenefits.css';

const BENEFITS = [
  {
    title: 'Priority Access',
    description: 'Be among the first to access Lummo when we launch. No additional waiting lists.',
    tag: 'EARLY',
  },
  {
    title: 'Exclusive Discounts',
    description: 'Up to 30% off your first year and preferential pricing for life.',
    tag: 'SAVINGS',
  },
  {
    title: 'Custom Package',
    description: 'Tailored proposal based on your specific needs and budget.',
    tag: 'TAILORED',
  },
  {
    title: 'Private Demo',
    description: 'Exclusive session with our founders to see Lummo in action.',
    tag: 'DEMO',
  },
];

const ContactBenefits: React.FC = () => (
  <section className="contact-benefits">
    <div className="container">
      <ScrollReveal className="contact-benefits__header">
        <span className="contact-benefits__eyebrow">Waitlist perks</span>
        <h2>What you get by joining</h2>
        <p>
          As a waitlist member, you get exclusive benefits and early access to the future of clinical
          trials in LATAM.
        </p>
      </ScrollReveal>

      <div className="contact-benefits__grid">
        {BENEFITS.map((benefit, index) => (
          <motion.article
            key={benefit.tag}
            className="contact-benefits__card"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            whileHover={{ y: -6 }}
            viewport={{ once: true, margin: '-40px' }}
            transition={{ delay: index * 0.06, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          >
            <span className="contact-benefits__tag">{benefit.tag}</span>
            <h3>{benefit.title}</h3>
            <p>{benefit.description}</p>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);

export default ContactBenefits;
